import React from "react";
import PropTypes from "prop-types";

const BotBlogrButton = React.forwardRef(
  (
    {
      onClick,
      children,
      icon: Icon,
      variant = "primary",
      className = "",
      type = "button",
      ...rest
    },
    ref
  ) => {
    const baseStyles = "rounded font-light flex items-center gap-2";

    const variantStyles = {
      primary: "bg-primary hover:bg-blue-200 text-white px-5 py-[6px] mt-3",
      blue100: "px-5 py-[6px] bg-blue-100 hover:bg-blue-200 text-white",
      success: "bg-success hover:bg-success_hover text-white px-5 py-[6px] mt-3",
      white: "bg-white text-black focus:outline-none px-5 py-[6px] mt-3",
      blueLight: "bg-blue-50 hover:bg-blue-200 text-white px-5 py-[6px]",
      danger: "bg-red-500 hover:bg-red-600 text-white px-5 py-[6px] mt-3",
      icon: "h-8 w-8 flex items-center justify-center bg-Lightwhite text-gray hover:text-blue-50 !rounded-full font-light",
      violet: "bg-violet-600 hover:bg-violet-700 text-white px-4 py-1.5",
      green: "bg-green-600 hover:bg-green-700 text-white px-4 py-1.5",
      blue: "bg-blue-500 hover:bg-blue-600 text-white px-4 py-1.5",
      grayLocal: "bg-gray_local-400 hover:bg-gray_local-400/70 text-white px-5 py-[6px] mt-3",
      transparent: "bg-transparent hover:underline px-0 py-0 font-light",
      dangerSolid: "bg-error hover:bg-red-500 text-white text-sm font-semibold shadow-sm px-3 py-2",
      cancel: "bg-white text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 text-sm font-semibold shadow-sm px-3 py-2",
      pink: "text-sm bg-pink-600 hover:bg-pink-700 text-white disabled:bg-slate-200 disabled:text-slate-400 font-light px-5 py-2 rounded flex items-center",

    };

    const combinedStyles = `${baseStyles} ${variantStyles[variant] || ""} ${className}`;

    return (
      <button
        ref={ref}
        type={type}
        onClick={onClick}
        className={combinedStyles}
        {...rest}
      >
        {Icon && <Icon style={{ height: "20px", width: "20px" }} />}
        {children}
      </button>
    );
  }
);

// Optional: give it a name for React DevTools
BotBlogrButton.displayName = "BotBlogrButton";

BotBlogrButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  icon: PropTypes.elementType,
  variant: PropTypes.oneOf([
    "primary",
    "blue100",
    "success",
    "white",
    "blueLight",
    "danger",
    "icon",
    "violet",
    "green",
    "blue",
    "grayLocal",
    "transparent",
    "dangerSolid",
    "cancel",
    "pink",
  ]),
  className: PropTypes.string,
  type: PropTypes.string,
};

export default BotBlogrButton;
